/* eslint-disable */
import { SIDEBAR_OPEN } from '../Sidebar.types';

/**
 * Open the sidebar
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_OPEN>>} The created `Action`
 */
const sidebarOpen = () => ({ fromPayload }) => {
  return fromPayload(null, {}, SIDEBAR_OPEN);
};

export default sidebarOpen;
